import React from 'react';
import { withFormik } from 'formik';
import { FormikPropTypes } from '../../../forms/helpers/formikPropTypes';
import BasicInput from '../../../forms/fields/BasicInput';

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    //this._handleRoleChange = this._handleRoleChange.bind(this);
  }

  static propTypes = {
    ...FormikPropTypes
  };

  UNSAFE_componentWillReceiveProps(nextProps) {}

  render() {
    const props = this.props;

    return (
      <form className="m-form" onSubmit={props.handleSubmit}>
        <div className="m-portlet__body">
          <input type="hidden" name="id" />

          <BasicInput
            {...props}
            name="barcode"
            type="text"
            label="Barcode"
            id="materialBarcode"
          />
        </div>
        <div className="m-portlet__foot">
          <div className="row align-items-center">
            <div className="col-lg-12 m--align-right">
              <button
                className={
                  'btn m-btn btn-primary' +
                  (props.isSubmitting
                    ? ' m-btn--custom m-loader m-loader--light m-loader--left'
                    : '')
                }
                disabled={props.isSubmitting}
              >
                Lookup
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const BoxOfficeCrewMaterialsForm = withFormik({
  mapPropsToValues: props => {
    let values = {
      barcode: ''
    };

    return values;
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.barcode || values.barcode === '') {
      errors.barcode = 'required';
    }

    return errors;
  },

  handleSubmit: (values, { props, resetForm }) => {
    props
      .onSubmit(values)
      .then()
      .catch()
      .then(reponse => {
        resetForm();
        document.querySelector('input[name=barcode]').focus();
      });
  }
})(InnerForm);

export default BoxOfficeCrewMaterialsForm;
